<template>
  <modal
    v-slot="{ data }"
    name="orderingError"
    modal-style="compact"
    :is-required="true"
    :display-header-title="false"
  >
    <ordering-error :data="data" />
  </modal>
</template>


<script>
  import OrderingError from './ordering-error/index.vue';


  export default {
    name: 'OrderingErrorModal',

    components: {
      OrderingError
    }
  };
</script>
